<ml-diagnostic-submission-ui (diagnosticSubmission)="diagnosticSubmission($event)"></ml-diagnostic-submission-ui>